"use strict";
/*
 * Created on 11.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var ActionFeasibility_1 = require("../model/ActionFeasibility");
/**
 * @author MSu
 */


var ActionFeasibilityConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ActionFeasibilityConverter, _DataObjectConverter_);

  function ActionFeasibilityConverter() {
    _classCallCheck(this, ActionFeasibilityConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActionFeasibilityConverter).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(ActionFeasibilityConverter, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ActionFeasibility_1.ActionFeasibility(source.actionType, conversions.asObjectList(source, 'tags', function (v) {
        return v;
      }), this.validationResultConverter.toObject(source.validationResult, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        actionType: source.actionType,
        tags: conversions.asObjectArray(source, 'tags', function (v) {
          return v;
        }),
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions)
      };
    }
  }]);

  return ActionFeasibilityConverter;
}(DataObjectConverter_1.DataObjectConverter);

__decorate([typescript_ioc_1.Inject, __metadata("design:type", ValidationResultConverter_1.ValidationResultConverter)], ActionFeasibilityConverter.prototype, "validationResultConverter", void 0);

exports.ActionFeasibilityConverter = ActionFeasibilityConverter;